var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { CycleInfo } from './modules/CycleInfo';
import { CycleGrade } from './modules/CycleGrade';
import { CycleNavigate } from './modules/CycleNavigate';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { CycleAnswers } from './modules/CycleAnswers';
import { CycleReward } from './modules/CycleReward';
import { CycleBranding } from './modules/CycleBranding';
export class Cycle {
    parent;
    cycleIndex;
    constructor(parent, cycleIndex) {
        makeObservable(this);
        this.parent = parent;
        this.cycleIndex = cycleIndex;
        /*
        this.measure.startDate = this.app.appClock.currentDate;
        if (this.app.appInfo.isMobileAppWebView) {
          this.nativeApp = new CycleNativeApp(this);
        } */
    }
    get app() {
        return this.parent;
    }
    get cycleAnswers() {
        return new CycleAnswers(this);
    }
    get cycleNavigate() {
        return new CycleNavigate(this);
    }
    get cycleInfo() {
        return new CycleInfo(this);
    }
    get cycleGrade() {
        return new CycleGrade(this);
    }
    get cycleBranding() {
        return new CycleBranding(this);
    }
    get cycleReward() {
        return new CycleReward(this);
    }
    get frontalIndex() {
        if (this.app.appInfo.isWebViewInAndroidApp)
            return 0;
        return this.app.tray.trayLine.indexOfFrontalAnswer - this.cycleAnswers.trayIndexOfFirstCycleAnswer;
    }
    get frontalNumber() {
        return this.frontalIndex + 1;
    }
    get numberOfQuestionsInCycle() {
        if (false && this.app.menubarRight.isMultiPlayerMode) {
            return Math.max(this.app.multi.race.ownRunner.timeRecords.length + 1, this.frontalNumber + 1);
        }
        return this.cycleAnswers.allAnswersInCycle.length;
    }
}
__decorate([
    memoize
], Cycle.prototype, "cycleAnswers", null);
__decorate([
    memoize
], Cycle.prototype, "cycleNavigate", null);
__decorate([
    memoize
], Cycle.prototype, "cycleInfo", null);
__decorate([
    memoize
], Cycle.prototype, "cycleGrade", null);
__decorate([
    memoize
], Cycle.prototype, "cycleBranding", null);
__decorate([
    memoize
], Cycle.prototype, "cycleReward", null);
__decorate([
    computed
], Cycle.prototype, "numberOfQuestionsInCycle", null);
